// API 配置：通过环境变量对接反向代理，勿写死公网域名

/** 统一订单详情接口路径（相对 API 根，如 /api） */
const COMMON_INTERFACE_PATH = '/SendTransaction/CommonInterface';

function normalizeApiBase(base) {
  const b = (base || '/api').trim();
  return b.replace(/\/+$/, '') || '/api';
}

/**
 * HTTP：与页面同源的相对路径，由 Nginx 将 /api 转到真实网关
 * 开发时由 vue.config.js 的 devServer.proxy 转发
 */
function getCommonInterfaceUrl() {
  const base = normalizeApiBase(process.env.VUE_APP_API_BASE_URL);
  return `${base}${COMMON_INTERFACE_PATH}`;
}

/**
 * WebSocket：
 * - 若设置 VUE_APP_WS_URL（完整地址），优先使用（单地址覆盖）
 * - 否则按页面协议选用 VUE_APP_WS_WSS_URL / VUE_APP_WS_WS_URL（网关双配置，HTTPS 用 wss）
 * - 再否则使用当前页面的 host + VUE_APP_WS_PATH（默认 /ws），便于 Nginx 反代 Upgrade
 */
function getWebSocketUrl() {
  const explicit = process.env.VUE_APP_WS_URL;
  if (explicit != null && String(explicit).trim() !== '') {
    return String(explicit).trim();
  }
  if (typeof window === 'undefined') {
    return 'ws://127.0.0.1:2346';
  }
  const wssUrl = process.env.VUE_APP_WS_WSS_URL;
  const wsUrl = process.env.VUE_APP_WS_WS_URL;
  const secure = window.location.protocol === 'https:';
  if (secure) {
    if (wssUrl != null && String(wssUrl).trim() !== '') {
      return String(wssUrl).trim();
    }
  } else if (wsUrl != null && String(wsUrl).trim() !== '') {
    return String(wsUrl).trim();
  }
  let path = process.env.VUE_APP_WS_PATH || '/ws';
  path = path.startsWith('/') ? path : `/${path}`;
  const proto = secure ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${path}`;
}

export default {
  getCommonInterfaceUrl,
  getWebSocketUrl,
  config: {
    COMMON_INTERFACE_PATH,
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL || '/api'
  }
};
